import CollapsibleField from './CollapsibleField';

interface CollapsibleViewProps {
  data: object;
  showNull: boolean;
  expandAll: boolean;
}

const CollapsibleView = ({ data, showNull, expandAll }: CollapsibleViewProps) => {
  return (
    <div className="bg-white border border-slate-200 rounded max-h-[70vh] overflow-y-auto overflow-x-hidden text-sm">
      {Object.entries(data)
        .filter(([_key, value]) => showNull || value !== null)
        .map(([key, value]) => (
          <CollapsibleField
            key={key}
            fieldKey={key}
            value={value}
            depth={0}
            showNull={showNull}
            expandAll={expandAll}
          />
        ))}
    </div>
  );
};

export default CollapsibleView;
